module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e87650f1dc477d708bd4a839c7bde4a8.svg";